import React from "react";

const JewelIcon = ({className, iconClassName}) => {
  
   

  return (
    
                
    <div className={` ${className} opacity-30 group-hover:opacity-70 `}>
    
      <svg xmlns="http://www.w3.org/2000/svg" space="preserve" viewBox="0 0 70 70" className={` ${iconClassName}`}>
        <path stroke="stroke-inherit" strokeWidth="1" d="M28.757 18.369c1.449-.284 3.224-.429 5.274-.429 9.194 0 9.301 2.125 9.301 2.146a1 1 0 1 0 2 0c0-2.751-3.803-4.146-11.301-4.146-2.18 0-4.083.157-5.659.466a1 1 0 0 0 .385 1.963m-2.923-.239a1 1 0 0 0-1.4-.201c-1.124.841-1.292 1.713-1.292 2.158 0 .553.448 1.004 1 1.004s1-.444 1-.997c.007-.056.112-.28.49-.563a1 1 0 0 0 .202-1.401"/>
        <path stroke="stroke-inherit" strokeWidth="1" d="M44.718 27.388c3.301-.744 5.77-3.608 5.77-7.157 0-2.855-1.607-9.351-16.5-9.351-15.551 0-16 8.378-16 9.351 0 3.485 2.381 6.308 5.592 7.113-6.176 3.629-10.342 10.326-10.342 17.993 0 11.511 9.364 20.875 20.875 20.875s20.875-9.364 20.875-20.875c-.001-7.637-4.134-14.309-10.27-17.949m-22.73-7.157c0-1.932 2.5-5.351 12-5.351 10.917 0 12.5 3.419 12.5 5.351s-1.551 3.352-3.467 3.352H25.455c-1.915 0-3.467-1.42-3.467-3.352m12.125 41.981c-9.32 0-16.875-7.555-16.875-16.875s7.555-16.875 16.875-16.875 16.875 7.555 16.875 16.875-7.555 16.875-16.875 16.875M16 19.583a2 2 0 0 0-2-2h-3a2 2 0 0 0 0 4h3a2 2 0 0 0 2-2m1.134-9.168c.39.391.902.586 1.414.586s1.024-.195 1.414-.586a2 2 0 0 0 0-2.828l-2.121-2.121a2 2 0 1 0-2.828 2.828zM58 17.583h-3a2 2 0 0 0 0 4h3a2 2 0 0 0 0-4m-8.013-6.582a2 2 0 0 0 1.414-.586l2.121-2.121a2 2 0 1 0-2.828-2.828l-2.121 2.121a2 2 0 0 0 1.414 3.414M34.583 9a2 2 0 0 0 2-2V5a2 2 0 0 0-4 0v2a2 2 0 0 0 2 2"/>
      </svg>    
                
    </div>       
              
             
           
  );
};

export default JewelIcon;